export function registerNavigationItemsTrait(editor) {
    const traitManager = editor.TraitManager;

    traitManager.addType('navigation-items', {
        createInput({ component }) {
            const wrapper = document.createElement('div');

            const createField = ({ label, value, onInput, type = 'text' }) => {
                const field = document.createElement('div');
                const fieldLabel = document.createElement('label');
                const input = document.createElement('input');

                field.className = 'navigation-item__field';

                fieldLabel.className = 'navigation-item__label';
                fieldLabel.textContent = label;

                input.className = 'navigation-item__input';
                input.type = type;
                input.value = value ?? '';

                input.addEventListener('input', onInput);

                field.appendChild(fieldLabel);
                field.appendChild(input);

                return field;
            };

            const createRemoveButton = (index) => {
                const button = document.createElement('button');

                button.className = 'navigation-item__remove';
                button.type = 'button';
                button.textContent = '×';
                button.title = 'Remove item';

                button.addEventListener('click', () => {
                    const items = [...(component.get('navigationItems') || [])];

                    items.splice(index, 1);

                    component.set('navigationItems', items);

                    render();
                });

                return button;
            };

            const createItemElement = (item, index) => {
                const element = document.createElement('div');
                const header = document.createElement('div');
                const title = document.createElement('span');

                element.className = 'navigation-item';
                header.className = 'navigation-item__header';
                title.className = 'navigation-item__title';

                title.textContent = `Element ${index + 1}`;

                header.appendChild(title);
                header.appendChild(createRemoveButton(index));

                element.appendChild(header);

                element.appendChild(
                    createField({
                        label: 'Label',
                        value: item.label,
                        onInput: (event) => {
                            const items = [
                                ...(component.get('navigationItems') || []),
                            ];

                            items[index] = {
                                ...items[index],
                                label: event.target.value,
                            };

                            component.set('navigationItems', items);
                        },
                    })
                );

                element.appendChild(
                    createField({
                        label: 'ID',
                        value: item.id,
                        onInput: (event) => {
                            const items = [
                                ...(component.get('navigationItems') || []),
                            ];

                            items[index] = {
                                ...items[index],
                                id: event.target.value,
                            };

                            component.set('navigationItems', items);
                        },
                    })
                );

                element.appendChild(
                    createField({
                        label: 'Sortierung',
                        value: item.sort,
                        onInput: (event) => {
                            const items = [
                                ...(component.get('navigationItems') || []),
                            ];

                            const value = event.target.value;

                            items[index] = {
                                ...items[index],
                                sort: value === '' ? undefined : Number(value),
                            };

                            component.set('navigationItems', items);
                        },
                        type: 'number',
                    })
                );

                return element;
            };

            const createAddButton = () => {
                const button = document.createElement('button');

                button.className = 'navigation-items__add';
                button.type = 'button';
                button.textContent = '+ Navigationselement hinzufügen';

                button.addEventListener('click', () => {
                    const items = [...(component.get('navigationItems') || [])];

                    items.push({
                        label: '',
                        id: '',
                        sort: '',
                    });

                    component.set('navigationItems', items);

                    render();
                });

                return button;
            };

            const render = () => {
                wrapper.innerHTML = '';

                const items = component.get('navigationItems') || [];

                items.forEach((item, index) => {
                    wrapper.appendChild(createItemElement(item, index));
                });

                wrapper.appendChild(createAddButton());
            };

            render();

            return wrapper;
        },
    });
}
